import { Logout } from "./components/Logout";

export default Logout;
